import Utils from "../../../../../../shared/utils";

export const COPY_ICON = Utils.buildMortPersonalAreaImgLink("icons/copy.svg");
export const CHEVRON_DOWN = Utils.buildMortPersonalAreaImgLink("icons/chevron-down.svg");